import { Pinia, Store } from 'pinia-class-component';
import { initClient } from '../../api';
import { GroupType, TestEquipmentGroupTypeAPIControllerUIClient } from '../../components/backend/backendapi';

@Store({
  id: 'GroupTypeStore',
  name: 'GroupTypeStore',
})
export default class GroupTypeStore extends Pinia {
  private readonly api = initClient(TestEquipmentGroupTypeAPIControllerUIClient);

  //data
  private _loadingPromise: Promise<GroupType[]> | null = null;
  private _groupTypes: GroupType[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get groupTypes(): GroupType[] {
    return this._groupTypes;
  }

  get groupTypesById(): Map<number, GroupType> {
    return new Map(this._groupTypes.map(e => [e.id, e]));
  }

  //actions
  clear(): void {
    this._groupTypes.splice(0);
  }

  setGroupTypes(groupTypes: GroupType[]): void {
    this._groupTypes.splice(0);
    this._groupTypes.push(...groupTypes);
  }

  rememberGroupType(groupType: GroupType): void {
    const index = this._groupTypes.findIndex(e => e.id === groupType.id);
    if (index >= 0) {
      this._groupTypes.splice(index, 1, groupType);
    } else {
      this._groupTypes.push(groupType);
    }
  }

  forgetGroupType(groupType: GroupType): void {
    const index = this._groupTypes.findIndex(e => e.id === groupType.id);
    if (index >= 0) {
      this._groupTypes.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.api.list();
      const groupTypes = await this._loadingPromise;
      this.setGroupTypes(groupTypes ?? []);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._groupTypes.length > 0) {
      return;
    }
    return await this.reload();
  }
}